import { useDispatch } from 'react-redux';

import { Box, Button, Heading, Modal, Text } from '@zillow/constellation-10';

import ApplicationActions from '../../../actions/ApplicationActions';

import TermsAndConditionsActions from '../../../actions/TermsAndConditionsActions';

import ListingActivationTerms from '../../../components/ListingActivationTerms';

import type { Dispatch, SetStateAction } from 'react';

const bodyText =
  'By enabling applications, renters on Zillow, Trulia and HotPads will be able to apply directly from your active rental listings.';
const buttonTitle = 'Enable applications';

type Props = {
  setShowEnableApplicationsModal: Dispatch<SetStateAction<boolean>>;
  setDisplayApplicationsNotification?: Dispatch<SetStateAction<boolean>>;
  onConfirm?: () => void;
};

const EnableApplicationsModal = ({
  setShowEnableApplicationsModal,
  setDisplayApplicationsNotification,
  onConfirm,
}: Props) => {
  const dispatch = useDispatch();

  const onConfirmClick = () => {
    dispatch(ApplicationActions.enableApplications())
      // @ts-expect-error
      .then(() => {
        dispatch(TermsAndConditionsActions.markAcceptedTerms());
        setShowEnableApplicationsModal(false);
        setDisplayApplicationsNotification?.(true);
      });
    onConfirm?.();
  };

  const onClose = () => {
    setShowEnableApplicationsModal(false);
  };

  return (
    <Modal
      header={
        <Heading level={1} textStyle="body-lg-bold">
          Enable applications
        </Heading>
      }
      body={
        <>
          <Text textStyle="heading-sm" asChild>
            <p>Simplify your rental process.</p>
          </Text>
          <Box css={{ marginBlock: '400' }}>
            <Text asChild css={{ marginBottom: '200' }}>
              <p>{bodyText}</p>
            </Text>
            <Text asChild>
              <p>You can also invite specific renters to apply for any of your properties.</p>
            </Text>
          </Box>
          <Button tone="brand" emphasis="filled" onClick={onConfirmClick}>
            {buttonTitle}
          </Button>
          <ListingActivationTerms actionText={`By clicking ${buttonTitle}`} />
        </>
      }
      onOpenChange={(open) => !open && onClose()}
      open={true}
      size={{ base: 'fullScreen', md: 'md' }}
    />
  );
};

export default EnableApplicationsModal;
